define(function (require) {
    "use strict";

    var isIE = /*@cc_on!@*/!1;

    // object.watch
    if (!isIE && !Object.prototype.watch) {
        window.watch = function (prop, handler) {
            var oldval = this[prop];
            var newval = oldval;

            var getter = function () {
                return newval;
            };

            var setter = function (val) {
                oldval = newval;
                newval = handler.call(this, prop, oldval, val);

                return newval;
            };

            if (delete this[prop]) { // can't watch constants
                if (window.defineProperty) {// ECMAScript 5
                    window.defineProperty(this, prop, {
                        get:getter,
                        set:setter
                    });
                } else if (window.__defineGetter__ && window.__defineSetter__) { // legacy
                    window.__defineGetter__.call(this, prop, getter);
                    window.__defineSetter__.call(this, prop, setter);
                }
            }
        };
    }

    // object.unwatch
    if (!isIE && !Object.prototype.unwatch) {
        window.unwatch = function (prop) {
            var val = this[prop];
            delete this[prop]; // remove accessors
            this[prop] = val;
        };
    }
});